<template>
  <div class="l-container">
    <!-- <div>{{obj}}</div> -->

    <p class="m-label">生徒選択
      <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
      <span>
        <template v-if="this.sortColumn2 === 'id'">ID</template>
        <template v-if="this.sortColumn2 === 'family_name'">家庭</template>
        <template v-if="this.sortColumn2 === 'family_kana'">かな</template>
        <template v-if="this.sortColumn2 === 'name'">生徒</template>
        <template v-if="this.sortColumn2 === 'kana'">かな</template>
        <template v-if="this.sortColumn2 === 'grade'">学年</template>
        <template v-if="this.sortColumn2 === 'pref'">都道府県</template>
        <template v-if="this.sortColumn2 === 'address'">住所</template>
        <template v-if="this.sortColumn2 === 'tel1'">TEL1</template>
        <template v-if="this.sortColumn2 === 'created_at'">作成日</template>
         : {{sortState2}}
      </span>
    </p>
    <div class="index-box StudentfilesIndex" @scroll="offset">
      <table-c>
        <tr-c slot="tr-th">
          <td-c><input v-model="search2.id" type="text" @keyup="searchTable2()" placeholder="検索"></td-c>
          <td-c><input v-model="search2.family_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.family_kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c class="select">
            <multiselect @select="searchTable2()" v-model="watchSearch2.grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c class="select">
            <multiselect @select="searchTable2()" v-model="watchSearch2.pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c><input v-model="search2.address" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.created_at" type="text" @keyup="searchTable2()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c><input v-model="search2.not_id" type="text" @keyup="searchTable2()" placeholder="除外"></td-c>
          <td-c><input v-model="search2.not_family_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_family_kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c class="select">
            <multiselect @select="searchTable2()" v-model="watchSearch2.not_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c class="select">
            <multiselect @select="searchTable2()" v-model="watchSearch2.not_pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c><input v-model="search2.not_address" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_created_at" type="text" @keyup="searchTable2()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c @click.native='sort2("id")'>ID</th-c>
          <th-c @click.native='sort2("family_name")'>家庭</th-c>
          <th-c @click.native='sort2("family_kana")'>かな</th-c>
          <th-c @click.native='sort2("name")'>生徒</th-c>
          <th-c @click.native='sort2("kana")'>かな</th-c>
          <th-c @click.native='sort2("grade")'>学年</th-c>
          <th-c @click.native='sort2("pref")'>都道府県</th-c>
          <th-c @click.native='sort2("address")'>住所</th-c>
          <th-c @click.native='sort2("tel1")'>TEL1</th-c>
          <th-c @click.native='sort2("created_at")'>作成日</th-c>
        </tr-c>

        <tr-c slot="tr-td" @click.native="getId(student)" v-for="student in orderedStudents" :key="student.id">
          <template v-if="studentfile.student_id === student.id">
            <td-c class="clicked">{{student.id}}</td-c>
            <td-c class="clicked">{{student.family.f_name}} {{student.family.l_name}}</td-c>
            <td-c class="clicked">{{student.family.f_name_kana}} {{student.family.l_name_kana}}</td-c>
            <td-c class="clicked">{{student.f_name}} {{student.l_name}}</td-c>
            <td-c class="clicked">{{student.f_name_kana}} {{student.l_name_kana}}</td-c>
            <template>
              <td-c class="clicked" v-if="student.grade === 0">未選択</td-c>
              <td-c class="clicked" v-if="student.grade === 1">1</td-c>
              <td-c class="clicked" v-if="student.grade === 2">2</td-c>
              <td-c class="clicked" v-if="student.grade === 3">3</td-c>
              <td-c class="clicked" v-if="student.grade === 4">4</td-c>
              <td-c class="clicked" v-if="student.grade === 5">5</td-c>
              <td-c class="clicked" v-if="student.grade === 6">6</td-c>
            </template>
            <template>
              <td-c class="clicked" v-if="student.family.pref === 0">未選択</td-c>
              <td-c class="clicked" v-if="student.family.pref === 1">北海道</td-c>
              <td-c class="clicked" v-if="student.family.pref === 2">青森県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 3">秋田県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 4">岩手県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 5">山形県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 6">宮城県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 7">福島県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 8">栃木県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 9">山梨県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 10">群馬県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 11">茨城県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 12">千葉県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 13">埼玉県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 14">東京都</td-c>
              <td-c class="clicked" v-if="student.family.pref === 15">神奈川県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 16">静岡県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 17">長野県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 18">愛知県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 19">岐阜県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 20">新潟県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 21">富山県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 22">石川県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 23">福井県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 24">滋賀県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 25">京都府</td-c>
              <td-c class="clicked" v-if="student.family.pref === 26">三重県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 27">和歌山県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 28">奈良県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 29">大阪府</td-c>
              <td-c class="clicked" v-if="student.family.pref === 30">兵庫県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 31">鳥取県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 32">島根県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 33">岡山県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 34">広島県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 35">山口県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 36">高知県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 37">徳島県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 38">香川県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 39">愛媛県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 40">福岡県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 41">佐賀県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 42">長崎県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 43">熊本県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 44">宮崎県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 45">大分県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 46">鹿児島県</td-c>
              <td-c class="clicked" v-if="student.family.pref === 47">沖縄県</td-c>
            </template>
            <td-c class="clicked">{{student.family.address1}}{{student.family.address2}}</td-c>
            <td-c class="clicked">{{student.family.tel1}}</td-c>
            <td-c class="clicked">{{student.created_at.substring(0, 10)}}</td-c>
          </template>

          <template v-if="studentfile.student_id !== student.id">
            <td-c>{{student.id}}</td-c>
            <td-c>{{student.family.f_name}} {{student.family.l_name}}</td-c>
            <td-c>{{student.family.f_name_kana}} {{student.family.l_name_kana}}</td-c>
            <td-c>{{student.f_name}} {{student.l_name}}</td-c>
            <td-c>{{student.f_name_kana}} {{student.l_name_kana}}</td-c>
            <template>
              <td-c v-if="student.grade === 0">未選択</td-c>
              <td-c v-if="student.grade === 1">1</td-c>
              <td-c v-if="student.grade === 2">2</td-c>
              <td-c v-if="student.grade === 3">3</td-c>
              <td-c v-if="student.grade === 4">4</td-c>
              <td-c v-if="student.grade === 5">5</td-c>
              <td-c v-if="student.grade === 6">6</td-c>
            </template>
            <template>
              <td-c v-if="student.family.pref === 0">未選択</td-c>
              <td-c v-if="student.family.pref === 1">北海道</td-c>
              <td-c v-if="student.family.pref === 2">青森県</td-c>
              <td-c v-if="student.family.pref === 3">秋田県</td-c>
              <td-c v-if="student.family.pref === 4">岩手県</td-c>
              <td-c v-if="student.family.pref === 5">山形県</td-c>
              <td-c v-if="student.family.pref === 6">宮城県</td-c>
              <td-c v-if="student.family.pref === 7">福島県</td-c>
              <td-c v-if="student.family.pref === 8">栃木県</td-c>
              <td-c v-if="student.family.pref === 9">山梨県</td-c>
              <td-c v-if="student.family.pref === 10">群馬県</td-c>
              <td-c v-if="student.family.pref === 11">茨城県</td-c>
              <td-c v-if="student.family.pref === 12">千葉県</td-c>
              <td-c v-if="student.family.pref === 13">埼玉県</td-c>
              <td-c v-if="student.family.pref === 14">東京都</td-c>
              <td-c v-if="student.family.pref === 15">神奈川県</td-c>
              <td-c v-if="student.family.pref === 16">静岡県</td-c>
              <td-c v-if="student.family.pref === 17">長野県</td-c>
              <td-c v-if="student.family.pref === 18">愛知県</td-c>
              <td-c v-if="student.family.pref === 19">岐阜県</td-c>
              <td-c v-if="student.family.pref === 20">新潟県</td-c>
              <td-c v-if="student.family.pref === 21">富山県</td-c>
              <td-c v-if="student.family.pref === 22">石川県</td-c>
              <td-c v-if="student.family.pref === 23">福井県</td-c>
              <td-c v-if="student.family.pref === 24">滋賀県</td-c>
              <td-c v-if="student.family.pref === 25">京都府</td-c>
              <td-c v-if="student.family.pref === 26">三重県</td-c>
              <td-c v-if="student.family.pref === 27">和歌山県</td-c>
              <td-c v-if="student.family.pref === 28">奈良県</td-c>
              <td-c v-if="student.family.pref === 29">大阪府</td-c>
              <td-c v-if="student.family.pref === 30">兵庫県</td-c>
              <td-c v-if="student.family.pref === 31">鳥取県</td-c>
              <td-c v-if="student.family.pref === 32">島根県</td-c>
              <td-c v-if="student.family.pref === 33">岡山県</td-c>
              <td-c v-if="student.family.pref === 34">広島県</td-c>
              <td-c v-if="student.family.pref === 35">山口県</td-c>
              <td-c v-if="student.family.pref === 36">高知県</td-c>
              <td-c v-if="student.family.pref === 37">徳島県</td-c>
              <td-c v-if="student.family.pref === 38">香川県</td-c>
              <td-c v-if="student.family.pref === 39">愛媛県</td-c>
              <td-c v-if="student.family.pref === 40">福岡県</td-c>
              <td-c v-if="student.family.pref === 41">佐賀県</td-c>
              <td-c v-if="student.family.pref === 42">長崎県</td-c>
              <td-c v-if="student.family.pref === 43">熊本県</td-c>
              <td-c v-if="student.family.pref === 44">宮崎県</td-c>
              <td-c v-if="student.family.pref === 45">大分県</td-c>
              <td-c v-if="student.family.pref === 46">鹿児島県</td-c>
              <td-c v-if="student.family.pref === 47">沖縄県</td-c>
            </template>
            <td-c>{{student.family.address1}}{{student.family.address2}}</td-c>
            <td-c>{{student.family.tel1}}</td-c>
            <td-c>{{student.created_at.substring(0, 10)}}</td-c>
          </template>
        </tr-c>
      </table-c>
    </div>


    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目
      <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
      <span>
        <template v-if="this.sortColumn === 'id'">ID</template>
        <template v-if="this.sortColumn === 'company_id'">会社名</template>
        <template v-if="this.sortColumn === 'student_id'">生徒ID</template>
        <template v-if="this.sortColumn === 'student_name'">生徒</template>
        <template v-if="this.sortColumn === 'student_kana'">かな</template>
        <template v-if="this.sortColumn === 'month'">何月分</template>
        <template v-if="this.sortColumn === 'state'">現状</template>
        <template v-if="this.sortColumn === 'note'">備考</template>
        <template v-if="this.sortColumn === 'file_name'">ファイル名</template>
        <template v-if="this.sortColumn === 'points_english'">英語</template>
        <template v-if="this.sortColumn === 'points_mathematics'">数学</template>
        <template v-if="this.sortColumn === 'points_japanese'">国語</template>
        <template v-if="this.sortColumn === 'points_science'">理科</template>
        <template v-if="this.sortColumn === 'points_socialstudies'">社会</template>
        <template v-if="this.sortColumn === 'file'">ファイル</template>
        <template v-if="this.sortColumn === 'user'">登録者</template>
        <template v-if="this.sortColumn === 'created_at'">作成日</template>
         : {{sortState}}
      </span>
    </h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('company_id')" v-bind:class="{ 'active': company_id }">会社名</btn>
        <btn class="m-btn--column" @click.native="switchV('student_id')" v-bind:class="{ 'active': student_id }">生徒ID</btn>
        <btn class="m-btn--column" @click.native="switchV('student_name')" v-bind:class="{ 'active': student_name }">生徒</btn>
        <btn class="m-btn--column" @click.native="switchV('student_kana')" v-bind:class="{ 'active': student_kana }">かな</btn>
        <btn class="m-btn--column" @click.native="switchV('month')" v-bind:class="{ 'active': month }">何月分</btn>
        <btn class="m-btn--column" @click.native="switchV('state')" v-bind:class="{ 'active': state }">現状</btn>
        <btn class="m-btn--column" @click.native="switchV('note')" v-bind:class="{ 'active': note }">備考</btn>
        <btn class="m-btn--column" @click.native="switchV('file_name')" v-bind:class="{ 'active': file_name }">ファイル名</btn>
        <btn class="m-btn--column" @click.native="switchV('points_english')" v-bind:class="{ 'active': points_english }">英語</btn>
        <btn class="m-btn--column" @click.native="switchV('points_mathematics')" v-bind:class="{ 'active': points_mathematics }">数学</btn>
        <btn class="m-btn--column" @click.native="switchV('points_japanese')" v-bind:class="{ 'active': points_japanese }">国語</btn>
        <btn class="m-btn--column" @click.native="switchV('points_science')" v-bind:class="{ 'active': points_science }">理科</btn>
        <btn class="m-btn--column" @click.native="switchV('points_socialstudies')" v-bind:class="{ 'active': points_socialstudies }">社会</btn>
        <btn class="m-btn--column" @click.native="switchV('file')" v-bind:class="{ 'active': file }">ファイル</btn>
        <btn class="m-btn--column" @click.native="switchV('user')" v-bind:class="{ 'active': user }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <div style="display: flex" class="StudentfilesIndex_upload">
      <form class="upload_form" method="post" enctype="multipart/form-data" @submit.prevent="postStudentfile" @keypress.stop.prevent.13>
        <div class="container">
          <input type="text" required class="input" v-model="studentfile.student_id" placeholder="Student ID">
          <input type="text" required maxlength="7" minlength="7" class="input" v-model="studentfile.month" placeholder="0001/01">
          <multiselect v-model="watch.state" :options="State" label="name" :show-labels="false" placeholder="現状"></multiselect>
          <textarea class="note" v-model="studentfile.note" type="text" placeholder="備考"></textarea>
          <multiselect v-model="watch.file_name" :options="fileName" label="name" :show-labels="false" placeholder="ファイル名"></multiselect>
          <div class="box">
            <i class="fa fa-camera"></i>
            <input @change="selectedFile" type="file" id="file">
          </div>
          <btn type="submit" class="upload">アップロード</btn>
        </div>

        <div class="container">
          <input type="text" class="points" v-model="studentfile.points_english" placeholder="英語">
          <input type="text" class="points" v-model="studentfile.points_mathematics" placeholder="数学">
          <input type="text" class="points" v-model="studentfile.points_japanese" placeholder="国語">
          <input type="text" class="points" v-model="studentfile.points_science" placeholder="理科">
          <input type="text" class="points" v-model="studentfile.points_socialstudies" placeholder="社会">
        </div>
      </form>
    </div>

    <div class="index-box2 StudentfilesIndex" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="company_id">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.company_id" :options="companies" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="student_id"><td-c><input v-model="search.student_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_name"><td-c><input v-model="search.student_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_kana"><td-c><input v-model="search.student_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="month"><td-c><input v-model="search.month" type="text" @keyup="searchTable()" placeholder="0001/01"></td-c></template>
          <template v-if="state">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.state" :options="State" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="note"><td-c><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file_name">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="points_english"><td-c><input v-model="search.points_english" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_mathematics"><td-c><input v-model="search.points_mathematics" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_japanese"><td-c><input v-model="search.points_japanese" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_science"><td-c><input v-model="search.points_science" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_socialstudies"><td-c><input v-model="search.points_socialstudies" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="user"><td-c><input v-model="search.user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="company_id">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.not_company_id" :options="companies" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="student_id"><td-c><input v-model="search.not_student_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_name"><td-c><input v-model="search.not_student_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_kana"><td-c><input v-model="search.not_student_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="month"><td-c><input v-model="search.not_month" type="text" @keyup="searchTable()" placeholder="0001/01"></td-c></template>
          <template v-if="state">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.not_state" :options="State" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="note"><td-c><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file_name">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.not_file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="points_english"><td-c><input v-model="search.not_points_english" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_mathematics"><td-c><input v-model="search.not_points_mathematics" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_japanese"><td-c><input v-model="search.not_points_japanese" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_science"><td-c><input v-model="search.not_points_science" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_socialstudies"><td-c><input v-model="search.not_points_socialstudies" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="user"><td-c><input v-model="search.not_user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="company_id"><th-c @click.native='sort("company_id")'>会社名</th-c></template>
          <template v-if="student_id"><th-c @click.native='sort("student_id")'>Student ID</th-c></template>
          <template v-if="student_name"><th-c @click.native='sort("student_name")'>生徒</th-c></template>
          <template v-if="student_kana"><th-c @click.native='sort("student_kana")'>生徒かな</th-c></template>
          <template v-if="month"><th-c @click.native='sort("month")'>何月分</th-c></template>
          <template v-if="state"><th-c @click.native='sort("state")'>現状</th-c></template>
          <template v-if="note"><th-c @click.native='sort("note")'>備考</th-c></template>
          <template v-if="file_name"><th-c @click.native='sort("file_name")'>ファイル名</th-c></template>
          <template v-if="points_english"><th-c @click.native='sort("points_english")'>英語</th-c></template>
          <template v-if="points_mathematics"><th-c @click.native='sort("points_mathematics")'>数学</th-c></template>
          <template v-if="points_japanese"><th-c @click.native='sort("points_japanese")'>国語</th-c></template>
          <template v-if="points_science"><th-c @click.native='sort("points_science")'>理科</th-c></template>
          <template v-if="points_socialstudies"><th-c @click.native='sort("points_socialstudies")'>社会</th-c></template>
          <template v-if="file"><th-c @click.native='sort("file")'>ファイル</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")'>User</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in mapStudentfiles" :key="list.id" class="tr_hover StudentfilesIndex_upload" v-bind:class="{ 'list-edit': list.id == edit_id.edit_id }">

          <template v-if="list.id == edit_id.edit_id">

            <td-c @click.native="cancelStudentfile(list)" class="del">戻る</td-c>
            <td-c @click.native="patchStudentfile(list)" class="del">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="company_id"><td-c>{{list.company}}</td-c></template>
            <template v-if="student_id"><td-c>{{list.student_id}}</td-c></template>
            <template v-if="student_name"><td-c>{{list.student.f_name}} {{list.student.l_name}}</td-c></template>
            <template v-if="student_kana"><td-c>{{list.student.f_name_kana}} {{list.student.l_name_kana}}</td-c></template>
            <template v-if="month"><td-c><input type="text" v-model="list.month"></td-c></template>
            <template v-if="state">
              <td-c class="select">
                <multiselect v-model="watchPatch.state" :options="State" label="name" :show-labels="false" placeholder="現状"></multiselect>
              </td-c>
            </template>
            <template v-if="note"><td-c><textarea type="text" v-model="list.note"></textarea></td-c></template>
            <template v-if="file_name">
              <td-c class="select">
                <multiselect v-model="watchPatch.file_name" :options="fileName" label="name" :show-labels="false" placeholder="ファイル名"></multiselect>
              </td-c>
            </template>
            <template v-if="points_english"><td-c><input type="text" v-model="list.points_english"></td-c></template>
            <template v-if="points_mathematics"><td-c><input type="text" v-model="list.points_mathematics"></td-c></template>
            <template v-if="points_japanese"><td-c><input type="text" v-model="list.points_japanese"></td-c></template>
            <template v-if="points_science"><td-c><input type="text" v-model="list.points_science"></td-c></template>
            <template v-if="points_socialstudies"><td-c><input type="text" v-model="list.points_socialstudies"></td-c></template>
            <template v-if="file">
              <td-c>
                <form class="update_form" enctype="multipart/form-data">
                  <input @change="patchSelectedFile" type="file" id="file">
                </form>
              </td-c>
            </template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>

          </template>

          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteStudentfile(list)" class="del">削除</td-c>
            <td-c @click.native="edit(list)" class="del">編集</td-c>
            <template v-if="id"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.id}}</a></template>
            <template v-if="company_id"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.company}}</a></template>
            <template v-if="student_id"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.student_id}}</a></template>
            <template v-if="student_name"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.student.f_name}} {{list.student.l_name}}</a></template>
            <template v-if="student_kana"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.student.f_name_kana}} {{list.student.l_name_kana}}</a></template>
            <template v-if="month"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.month}}</a></template>
            <template v-if="state">
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.state === 0">未選択</a>
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.state === 1">提出済</a>
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.state === 2">連絡済</a>
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.state === 3">未提出</a>
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.state === 4">テキスト未使用</a>
            </template>
            <template v-if="note"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.note}}</a></template>
            <template v-if="file_name">
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.file_name === 0">未選択</a>
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.file_name === 1">指導報告書</a>
              <a v-bind:href="linkStudentfile(list)" target="_blank" class="link" v-if="list.file_name === 2">引継文章</a>
            </template>
            <template v-if="points_english"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.points_english}}</a></template>
            <template v-if="points_mathematics"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.points_mathematics}}</a></template>
            <template v-if="points_japanese"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.points_japanese}}</a></template>
            <template v-if="points_science"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.points_science}}</a></template>
            <template v-if="points_socialstudies"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.points_socialstudies}}</a></template>
            <template v-if="file"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link"></a></template>
            <template v-if="user"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.user.user}}</a></template>
            <template v-if="created_at"><a v-bind:href="linkStudentfile(list)" target="_blank" class="link">{{list.created_at.substring(0, 10)}}</a></template>
          </template>

        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/studentfiles/search?limit=' + config.LIMIT
const url2 = getAPIURL() + '/api/v1/students/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'studentfile',
  pageNames: 'studentfiles'
}

var obj2 = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url2,
  searchUrl: url2,
  pageName: 'student',
  pageNames: 'students'
}

let _ = window._
export default {
  data () {
    return {
      edit_id: {
        edit_id: ''
      },

      column: false,
      sortState: '降順',
      sortColumn: 'month',
      sortState2: '降順',
      sortColumn2: 'id',

      id: false,
      company_id: true,
      student_id: false,
      student_name: true,
      student_kana: true,
      month: true,
      state: true,
      note: true,
      file_name: true,
      points_english: true,
      points_mathematics: true,
      points_japanese: true,
      points_science: true,
      points_socialstudies: true,
      file: true,
      user: false,
      created_at: true,

      studentfile: {
        student_id: '',
        month: '',
        state: '',
        filing_date: moment().format('YYYY/MM/DD'), // 表示していない一応投げてる
        note: '',
        file_name: '',
        points_english: '',
        points_mathematics: '',
        points_japanese: '',
        points_science: '',
        points_socialstudies: '',
        file: ''
      },

      watch: {
        file_name: '',
        state: ''
      },

      PatchStudentfile: {
        state: '',
        file_name: '',
        file: ''
      },

      watchPatch: {
        file_name: '',
        state: ''
      },

      search: {
        id: '',
        company_id: '',
        student_id: '',
        student_name: '',
        student_kana: '',
        month: '',
        state: '',
        filing_date: '',
        note: '',
        file_name: '',
        points_english: '',
        points_mathematics: '',
        points_japanese: '',
        points_science: '',
        points_socialstudies: '',
        user: '',
        created_at: '',

        not_id: '',
        not_company_id: '',
        not_student_id: '',
        not_student_name: '',
        not_student_kana: '',
        not_month: '',
        not_state: '',
        not_filing_date: '',
        not_note: '',
        not_file_name: '',
        not_points_english: '',
        not_points_mathematics: '',
        not_points_japanese: '',
        not_points_science: '',
        not_points_socialstudies: '',
        not_user: '',
        not_created_at: ''
      },

      watchSearch: {
        company_id: '',
        file_name: '',
        state: '',

        not_company_id: '',
        not_file_name: '',
        not_state: ''
      },

      search2: {
        id: '',
        family_name: '',
        family_kana: '',
        name: '',
        kana: '',
        grade: '',
        pref: '',
        address: '',
        tel1: '',
        created_at: '',
        not_id: '',
        not_family_name: '',
        not_family_kana: '',
        not_name: '',
        not_kana: '',
        not_grade: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_created_at: ''
      },

      watchSearch2: {
        grade: '',
        pref: '',
        not_grade: '',
        not_pref: ''
      },

      fileName: [
        { name: '未選択', value: 0 },
        { name: '指導報告書', value: 1 },
        { name: '引継文章', value: 2 }
      ],

      State: [
        { name: '未選択', value: 0 },
        { name: '提出済', value: 1 },
        { name: '連絡済', value: 2 },
        { name: '未提出', value: 3 },
        { name: 'テキスト未使用', value: 4 }
      ],

      grade: [
        { name: '未選択', value: 0 },
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
        { name: '6', value: 6 }
      ],

      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ]
    }
  },
  computed: {
    obj () {
      return obj
    },

    companies () {
      return this.$store.getters.companies
    },

    studentfiles () {
      return this.$store.getters.studentfiles
    },

    orderedStudentfilesDefault () {
      return _.orderBy(this.studentfiles, this.created_at).reverse()
    },

    orderedStudentfiles () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.orderedStudentfilesDefault, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.orderedStudentfilesDefault, this.sortColumn)
      }
    },

    mapStudentfiles () {
      let self = this
      return self.orderedStudentfiles.map((studentfile) => {
        studentfile.company = self.calcCompany(studentfile.student.family.company_id)
        return studentfile
      })
    },

    students () {
      return this.$store.getters.students
    },

    orderedStudents () {
      if (this.sortState2 === '' || this.sortState2 === '降順') {
        return _.orderBy(this.students, this.sortColumn2).reverse()
      } else if (this.sortState2 === '昇順') {
        return _.orderBy(this.students, this.sortColumn2)
      }
    }
  },
  watch: {
    'watch.file_name': function (now, old) {
      if (now) {
        this.studentfile.file_name = now.value
      } else {
        this.studentfile.file_name = ''
      }
    },

    'watchPatch.file_name': function (now, old) {
      if (now) {
        this.PatchStudentfile.file_name = now.value
      } else {
        this.PatchStudentfile.file_name = ''
      }
    },

    'watchSearch.company_id': function (now, old) {
      if (now) {
        this.search.company_id = now.id
      } else {
        this.search.company_id = ''
      }
    },

    'watchSearch.not_company_id': function (now, old) {
      if (now) {
        this.search.not_company_id = now.id
      } else {
        this.search.not_company_id = ''
      }
    },

    'watchSearch.file_name': function (now, old) {
      if (now) {
        this.search.file_name = now.value
      } else {
        this.search.file_name = ''
      }
    },

    'watchSearch.not_file_name': function (now, old) {
      if (now) {
        this.search.not_file_name = now.value
      } else {
        this.search.not_file_name = ''
      }
    },

    'watch.state': function (now, old) {
      if (now) {
        this.studentfile.state = now.value
      } else {
        this.studentfile.state = ''
      }
    },

    'watchPatch.state': function (now, old) {
      if (now) {
        this.PatchStudentfile.state = now.value
      } else {
        this.PatchStudentfile.state = ''
      }
    },

    'watchSearch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watchSearch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = now.value
      } else {
        this.search.not_state = ''
      }
    },

    'watchSearch2.grade': function (now, old) {
      if (now) {
        this.search2.grade = now.value
      } else {
        this.search2.grade = ''
      }
    },

    'watchSearch2.not_grade': function (now, old) {
      if (now) {
        this.search2.not_grade = now.value
      } else {
        this.search2.not_grade = ''
      }
    },

    'watchSearch2.pref': function (now, old) {
      if (now) {
        this.search2.pref = now.value
      } else {
        this.search2.pref = ''
      }
    },

    'watchSearch2.not_pref': function (now, old) {
      if (now) {
        this.search2.not_pref = now.value
      } else {
        this.search2.not_pref = ''
      }
    }
  },
  methods: {
    calcCompany (val) {
      if (val) {
        return this.companies.filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    linkStudentfile (list) {
      let URL = config['production'].url
      if (process.env.NODE_ENV === 'development') {
        URL = 'http://localhost:8080'
      }
      let link = URL + '#/studentfile/view/' + list.id
      return link
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.company_id = false
      this.student_id = false
      this.student_name = false
      this.student_kana = false
      this.month = false
      this.state = false
      this.note = false
      this.file_name = false
      this.points_english = false
      this.points_mathematics = false
      this.points_japanese = false
      this.points_science = false
      this.points_socialstudies = false
      this.file = false
      this.user = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.companyid = true
      this.student_id = true
      this.student_name = true
      this.student_kana = true
      this.month = true
      this.state = true
      this.note = true
      this.file_name = true
      this.points_english = true
      this.points_mathematics = true
      this.points_japanese = true
      this.points_science = true
      this.points_socialstudies = true
      this.file = true
      this.user = true
      this.created_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    sort2 (header) {
      if (this.sortState2 === '' || this.sortState2 === '降順') {
        this.sortState2 = '昇順'
        this.sortColumn2 = header
      } else if (this.sortState2 === '昇順') {
        this.sortState2 = '降順'
        this.sortColumn2 = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable2 (e) {
      this.$store.dispatch('SEARCH2', {
        this: this,
        e: e,
        obj: obj2
      })
    },

    edit (list) {
      this.edit_id.edit_id = list.id
      this.watchPatch.file_name = this.fileName[list.file_name]
      this.watchPatch.state = this.State[list.state]
    },

    selectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.studentfile.file = files[0]
    },

    patchSelectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.PatchStudentfile.file = files[0]
    },

    postStudentfile () {
      this.$store.dispatch('postStudentfile', {
        this: this,
        studentfile: this.studentfile
      })
    },

    deleteStudentfile (list) {
      this.$store.dispatch('deleteStudentfile', {
        this: this,
        list: list
      })
    },

    cancelStudentfile (list) {
      this.$store.dispatch('cancelStudentfile', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchStudentfile (list) {
      this.$store.dispatch('patchStudentfile', {
        this: this,
        list: list,
        edit_id: this.edit_id,
        studentfile: this.PatchStudentfile
      })
    },

    getId (student) {
      this.studentfile.student_id = student.id
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.link {
  text-decoration: none;
  display: table-cell;
  vertical-align: middle;
  border-bottom: solid 1px #ccc;
  border-right: solid 1px #ccc;
  padding: .5rem;
}
.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}
.index-box {
  height: calc(50vh - 160px);
  overflow: scroll;
  margin-top: 10px;
}
.index-box2 {
  height: calc(50vh - 110px);
  overflow: scroll;
  margin-top: 10px;
}
.upload_form {
  .container {
    display: flex;
    .input {
      border: solid 1px #ccc;
      width: 150px;
      height: 36px;
      padding: 10px;
    }
    .points {
      border: solid 1px #ccc;
      width: 100px;
      height: 36px;
      padding: 10px;
    }
    .note {
      height: 36px;
      min-width: 400px;
      border: solid 1px #ccc;
    }
    .box {
      position: relative;
      .fa-camera {
        color: #ccc;
        font-size: 25px;
        padding: 7px;
        height: 36px;
        position: absolute;
        top: 0;
      }
      width: 100%;
      input[type="file"] {
        height: 36px;
        -webkit-appearance: none;
        appearance: none;
        border: solid 1px #ccc;
      }
      input[type="file"]::-webkit-file-upload-button {
        width: 36px;
        height: 36px;
        opacity: 0;
        -webkit-appearance: none;
        appearance: none;
      }
    }
  }
}
.upload {
  border: solid 1px #37474F;
  height: 36px;
  min-width: 120px;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
  background: #37474F;
  color: #fff;
}
.update_form {
}
.list-edit {
  .td {
    padding: 0 5px 0 5px;
    input {
      height: 23px;
      width: 100%;
    }
    textarea {
      height: 23px;
      width: 100%;
      outline: 0;
      border: none;
    }
  }
}
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem;
  border-right: solid 1px #ccc;
  min-width: 60px;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}
</style>

<style lang="scss">
.StudentfilesIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    // margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>

<style lang="scss">
.StudentfilesIndex_upload {
  .multiselect {
    min-height: 36px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    border-radius: 0;
    min-height: 36px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 36px;
  }
  .multiselect__select {
    height: 36px;
  }
  .multiselect__single {
    margin-top: 7px;
    margin-bottom: 7px;
  }
  .multiselect__placeholder {
    padding: 11px 3px;
    margin: 0;
    font-size: .85rem;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// StudentfilesIndex.vue?0ac68794